export const FETCH_ACCOUNT_PROPERTYS_MODAL_REQUEST = 'FETCH_ACCOUNT_PROPERTYS_MODAL_REQUEST';
export const FETCH_ACCOUNT_PROPERTYS_MODAL_SUCCESS = 'FETCH_ACCOUNT_PROPERTYS_MODAL_SUCCESS';
export const FETCH_ACCOUNT_PROPERTYS_MODAL_FAILURE = 'FETCH_ACCOUNT_PROPERTYS_MODAL_FAILURE';

export const FETCH_ACCOUNT_PROPERTY_MODAL_LIST_REQUEST = 'FETCH_ACCOUNT_PROPERTY_MODAL_LIST_REQUEST';
export const FETCH_ACCOUNT_PROPERTY_MODAL_LIST_SUCCESS = 'FETCH_ACCOUNT_PROPERTY_MODAL_LIST_SUCCESS';
export const FETCH_ACCOUNT_PROPERTY_MODAL_LIST_FAILURE = 'FETCH_ACCOUNT_PROPERTY_MODAL_LIST_FAILURE';


export const CREATE_USER_FORM_ACCOUNT_PROPERTY_MODAL = 'CREATE_USER_FORM_ACCOUNT_PROPERTY_MODAL';

export const CREATE_ACCOUNT_PROPERTYS_MODAL_REQUEST = 'CREATE_ACCOUNT_PROPERTYS_MODAL_REQUEST';
export const CREATE_ACCOUNT_PROPERTYS_MODAL_SUCCESS = 'CREATE_ACCOUNT_PROPERTYS_MODAL_SUCCESS';
export const CREATE_ACCOUNT_PROPERTYS_MODAL_FAILURE = 'CREATE_ACCOUNT_PROPERTYS_MODAL_FAILURE';

export const ACCOUNT_PROPERTY_MODAL_FORM_RESET = 'ACCOUNT_PROPERTY_MODAL_FORM_RESET';